import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button, Menu, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { firmsApi } from '../api/firms';
import { GeneralSection } from './FirmDetail/sections/GeneralSection';
import { FinancialSection } from './FirmDetail/sections/FinancialSection';
import { HistorySection } from './FirmDetail/sections/HistorySection';
import { RolesSection } from './FirmDetail/sections/RolesSection';
import { UsersSection } from './FirmDetail/sections/UsersSection';
import { FirmDataSourcesPanel } from '../components/firm/FirmDataSourcesPanel';
import { FirmAgentsPanel } from '../components/firm/FirmAgentsPanel';
import { FirmApiKeysPanel } from '../components/firm/FirmApiKeysPanel';
import { FirmLogsPanel } from '../components/firm/FirmLogsPanel';

export function FirmDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const firmId = parseInt(id || '0');
  const [section, setSection] = useState('general');

  const { data: firm, isLoading: firmLoading } = useQuery({
    queryKey: ['firm', firmId],
    queryFn: () => firmsApi.getById(firmId),
    enabled: !!firmId,
  });

  if (firmLoading) return <Spin />;
  if (!firm) return <Card>Firma bulunamadı</Card>;

  const items = [
    { key: 'general', label: 'Genel' },
    { key: 'sources', label: 'Veri Kaynakları' },
    { key: 'agent', label: 'Agent' },
    { key: 'apikeys', label: 'API Keys' },
    { key: 'logs', label: 'Loglar' },
    { type: 'divider' as const },
    { key: 'financial', label: 'Finansal' },
    { key: 'history', label: 'Tarihçe' },
    { key: 'roles', label: 'Roller' },
    { key: 'users', label: 'Kullanıcılar' },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/firms')}>
          Geri
        </Button>
        <h2 style={{ margin: 0 }}>{firm.name}</h2>
      </div>
      <div style={{ display: 'flex', gap: 16 }}>
        <Menu
          mode="inline"
          selectedKeys={[section]}
          onClick={(e) => setSection(e.key)}
          items={items}
          style={{ width: 220, flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          {section === 'general' && <GeneralSection firm={firm} />}
          {section === 'sources' && <FirmDataSourcesPanel firmId={firmId} agentBackend={firm.agentBackend} />}
          {section === 'agent' && (
            <FirmAgentsPanel
              firmId={firmId}
              agentBackend={firm.agentBackend}
              ittihatTenantId={firm.ittihatTenantId}
              erpType={firm.erpType}
            />
          )}
          {section === 'apikeys' && <FirmApiKeysPanel firmId={firmId} />}
          {section === 'logs' && <FirmLogsPanel firmId={firmId} />}
          {section === 'financial' && <FinancialSection firmId={firmId} />}
          {section === 'history' && <HistorySection firmId={firmId} />}
          {section === 'roles' && <RolesSection firmId={firmId} />}
          {section === 'users' && <UsersSection firmId={firmId} />}
        </div>
      </div>
    </div>
  );
}
